module.exports = __webpack_public_path__ + "img/20170704_135648_084.3e7af147.jpg";